<div class="m-t-40" *ngIf="ready && shouldShow">
  <span>{{ "products.atom_extras_elligible" | translate }} </span>
  <br />
  <button class="btn btn-primary m-t-10" (click)="redeemAtomExtras()">{{ redeeming ? ("general.redeeming_dots" | translate) : "Redeem Now" }}</button>
</div>
